import { Injectable } from '@angular/core';
import { type OrgUser } from '../../server/types/org-types';

@Injectable({
  providedIn: 'root',
})
export class ThumbnailService {
  constructor() {
    //
  }

  userThumbnail(user: OrgUser) {
    const { name } = user;
    // Determine letters
    let letters: string;
    const initials = name
      .split(' ')
      .filter((w) => w.length > 0)
      .map((w) => w[0])
      .join('');
    if (name.length < 4) {
      letters = name; // Don't capitalize
    } else if (initials.length < 4) {
      letters = initials.toUpperCase();
    } else {
      letters = name.substring(0, 3);
    }

    // URL encode SVGs of the initials https://yoksel.github.io/url-encoder/
    if (letters.length === 1) {
      // <svg height="64" width="64" style="background-color:hsl(111deg 100% 15%)">
      // <style>text{font-family:mono;font-size:40px}</style>
      // <text x="20" y="47" fill="white">Q</text>
      // </svg>
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='64' width='64' style='background-color:hsl(${user.color}deg 100%25 15%25)'%3E%3Cstyle%3Etext%7Bfont-family:mono;font-size:40px%7D%3C/style%3E%3Ctext x='20' y='47' fill='white'%3E${letters}%3C/text%3E%3C/svg%3E`;
    } else if (letters.length === 2) {
      // <svg height="64" width="64" style="background-color:hsl(111deg 100% 15%)">
      // <style>text{font-family:mono;font-size:40px}</style>
      // <text x="8" y="47" fill="white">QQ</text>
      // </svg>
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='64' width='64' style='background-color:hsl(${user.color}deg 100%25 15%25)'%3E%3Cstyle%3Etext%7Bfont-family:mono;font-size:40px%7D%3C/style%3E%3Ctext x='8' y='47' fill='white'%3E${letters}%3C/text%3E%3C/svg%3E`;
    } else if (letters.length === 3) {
      // <svg height="64" width="64" style="background-color:hsl(111deg 100% 15%)">
      // <style>text{font-family:mono;font-size:28px}</style>
      // <text x="7" y="42" fill="white">QQQ</text>
      // </svg>

      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='64' width='64' style='background-color:hsl(${user.color}deg 100%25 15%25)'%3E%3Cstyle%3Etext%7Bfont-family:mono;font-size:28px%7D%3C/style%3E%3Ctext x='7' y='42' fill='white'%3E${letters}%3C/text%3E%3C/svg%3E`;
    } else {
      // Red question mark
      return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='64' width='64' style='background-color:hsl(0deg 100%25 35%25)'%3E%3Cstyle%3Etext%7Bfont-family:mono;font-size:40px%7D%3C/style%3E%3Ctext x='20' y='47' fill='white'%3E%3F%3C/text%3E%3C/svg%3E";
    }
  }
}
